import React, { FC, ReactNode } from 'react';
import Dropzone, { DropzoneProps } from '../../Dropzone/Dropzone';

export interface FileInputProps {
    className?: string;
    hasError?: boolean;
    dropzoneProps?: Omit<DropzoneProps, 'onFile'>;
    onFile: (data: string | File) => void;
}

const FileInput: FC<FileInputProps> = props => {
    const { className } = props;

    function onFile(data: string | File): void {
        const { onFile } = props;

        onFile(data);
    }

    function renderDropzone(): ReactNode {
        const { dropzoneProps } = props;
        return (
            <Dropzone onFile={onFile} className="relative" {...dropzoneProps} />
        );
    }

    return (
        <div className={className}>
            {renderDropzone()}
        </div>
    );
};

export default FileInput;
